// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://phqugynpzmlqsayoqvhe.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBocXVneW5wem1scXNheW9xdmhlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ2NzcxMzgsImV4cCI6MjA3MDI1MzEzOH0.6lGvwKLfLCo9_ECvFyMYUruLcc4l3waqrLPcYT1dD1s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});